import React from 'react';

import './styles.css';

const Overlap = ({overlap}) => <div className="Overlap">{overlap}</div>;

export default Overlap;
